/**
 * Extracts uppercase initials from a full name string.
 * Mirrors the initials filter from collins-ui (src/js/filters/initials.js).
 *
 * @param name - The full name to extract initials from (e.g. "John Smith")
 * @returns Uppercase initials string (e.g. "JS"), or empty string if no name provided
 */
export const getInitials = (name: string | undefined): string => {
  if (!name) {
    return "";
  }

  return name
    .replace(/-/g, " ")
    .split(" ")
    .filter(Boolean)
    .map((part) => part.charAt(0))
    .join("")
    .toUpperCase();
};
